<div class="ng-doc-magnifier-container" [style.transform]="transform()">
  <ng-content></ng-content>
</div>
